// extracted by mini-css-extract-plugin
export var isPrintedCell = "_xq-1";
export var printerIcon = "_xq-0";